import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import AnimateHeight from "react-animate-height";
import { ChevronDown } from "react-feather";
import { thousandize, thousandizeString } from "../../../../util/formatting";
import style from "./DonationsAggregateImpactTable.module.scss";
import { AggregatedImpact, DK_OPERATIONS_KEY, GIVEWELL_ALL_GRANTS_FUND_KEY } from "./_util";
const multiFetcher = (...urls: string[]) => {
  const f = (u: string) => fetch(u).then(r => r.json());
  return Promise.all(urls.map(f));
};
export const DistributionsRow: React.FC<{
  outputkey: string;
  aggregatedimpact: AggregatedImpact;
}> = t0 => {
  const $ = _c(47);
  const {
    outputkey,
    aggregatedimpact
  } = t0;
  const [expanded, setExpanded] = useState(false);
  const impact = aggregatedimpact[outputkey];
  let requiredPrecision = 0;
  if ($[0] !== impact.outputs || $[1] !== requiredPrecision) {
    while (parseFloat(impact.outputs.toFixed(requiredPrecision)) === 0 && requiredPrecision < 3) {
      requiredPrecision = requiredPrecision + 1;
    }
    $[0] = impact.outputs;
    $[1] = requiredPrecision;
    $[2] = requiredPrecision;
  } else {
    requiredPrecision = $[2];
  }
  const t1 = Math.round(impact.outputs * Math.pow(10, requiredPrecision));
  const t2 = Math.pow(10, requiredPrecision);
  let t3;
  if ($[3] !== requiredPrecision || $[4] !== t1 || $[5] !== t2) {
    t3 = thousandizeString((t1 / t2).toFixed(requiredPrecision).replace(/\./, ","));
    $[3] = requiredPrecision;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const formattedOutput = t3;
  const isDriftRow = outputkey.toLowerCase().indexOf("drift") !== -1 || outputkey === DK_OPERATIONS_KEY;
  const isAllGrantsFundRow = outputkey === GIVEWELL_ALL_GRANTS_FUND_KEY;
  if (isDriftRow || isAllGrantsFundRow) {
    const label = isAllGrantsFundRow ? GIVEWELL_ALL_GRANTS_FUND_KEY : outputkey;
    let t4;
    if ($[7] !== label) {
      t4 = <span className={style.driftText}>{label}</span>;
      $[7] = label;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== formattedOutput) {
      t5 = <strong>{formattedOutput} kr</strong>;
      $[9] = formattedOutput;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t4 || $[12] !== t5) {
      t6 = <td colSpan={3} className={style.drift}>{t4} | {t5}</td>;
      $[11] = t4;
      $[12] = t5;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] !== outputkey || $[15] !== t6) {
      t7 = <tr key={outputkey}>{t6}</tr>;
      $[14] = outputkey;
      $[15] = t6;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    return t7;
  }
  let t4;
  if ($[17] !== expanded) {
    t4 = () => setExpanded(!expanded);
    $[17] = expanded;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== formattedOutput) {
    t5 = <strong>{formattedOutput}</strong>;
    $[19] = formattedOutput;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== outputkey) {
    t6 = <span>{outputkey}</span>;
    $[21] = outputkey;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t5 || $[24] !== t6) {
    t7 = <td>{t5} {t6}</td>;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const t8 = expanded ? "rotate(180deg)" : "";
  let t9;
  if ($[26] !== t8) {
    t9 = <td className={style.rowexpand}><ChevronDown size="1.3rem" color="white" style={{
        transform: t8
      }} /></td>;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== outputkey || $[29] !== t4 || $[30] !== t7 || $[31] !== t9) {
    t10 = <tr key={outputkey} onClick={t4} className={style.expandable} data-cy="donation-aggregate-impact-distribution-row">{t7}{t9}</tr>;
    $[28] = outputkey;
    $[29] = t4;
    $[30] = t7;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  const t11 = `${outputkey}-expander`;
  const t12 = expanded ? "auto" : 0;
  let t13;
  if ($[33] !== impact.constituents) {
    t13 = Object.keys(impact.constituents);
    $[33] = impact.constituents;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== impact.constituents || $[36] !== t13) {
    t14 = <div className={style.innertable}><table cellSpacing={0}><tbody>{t13.map(key => <tr key={key}><td>{key}</td><td>{thousandize(impact.constituents[key])} kr</td></tr>)}</tbody></table></div>;
    $[35] = impact.constituents;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t12 || $[39] !== t14) {
    t15 = <td colSpan={2}><AnimateHeight duration={300} height={t12} animateOpacity={true}>{t14}</AnimateHeight></td>;
    $[38] = t12;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t11 || $[42] !== t15) {
    t16 = <tr key={t11} data-cy="donation-aggregate-impact-distribution-row-details">{t15}</tr>;
    $[41] = t11;
    $[42] = t15;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t10 || $[45] !== t16) {
    t17 = <>{t10}{t16}</>;
    $[44] = t10;
    $[45] = t16;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  return t17;
};